import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { fetchInvitationDetails , fetchUpdateTravel , fetchSadirTravel} from '../../apiCall';
import CircularProgress from '@mui/material/CircularProgress';
import { Box } from '@mui/system';


function VerifyInvite() {

    const [showSpinner, setShowSpinner] = useState(true);
    const [showError, setShowError] = useState(false);
    const [verifyBtn, setAddVerifyBtn] = useState(false);
    const [successVerify, setSuccessVerify] = useState(false);
    const [QRscanned, setQRscanned] = useState(false);
    const [invitation, setInvitation] = useState({ orbit: {} });
    const [isCustomerApproved, setIsCustomerApproved] = useState(false);
    const [passenger, setPassenger] = useState({});


    const { id, type, date } = useParams();


    useEffect(()=>{
        getInvitation();
    }, [])

    const getInvitation = () => {
        fetchInvitationDetails(id , type , date , function(response) {
            setShowSpinner(true);
          if (!response.result || response == null) {
            setShowSpinner(false);
            setShowError(true);
          } else {


            if(response.result.passengers !==undefined){

              setInvitation(response.result.data);
              const passenger = response.result.passengers.find(
                (pass) => pass.connectedCustomerTravel === id
              );
              setPassenger(passenger)
              console.log(passenger.isQRCodeScanned)
              if(passenger.isQRCodeScanned === true){
                setQRscanned(true)
              }
              else{
                setAddVerifyBtn(true)
              }
              setShowSpinner(false);
            }
            
            
            else{
              console.log(response.result.isQRCodeScanned)
              if(response.result.isQRCodeScanned === true){
                setQRscanned(true)
              }else{
                setAddVerifyBtn(true)
              }
              setInvitation(response.result.data);
              if(response.result.isCustomerApproved !== undefined){
                  setIsCustomerApproved(true)
                  const invitationWithId = { ...response.result.data, id };
                  setInvitation(invitationWithId);
                  if(response.result.isQRCodeScanned === false || response.result.isQRCodeScanned === undefined ){
                      setAddVerifyBtn(true)
                  }else{
                    if(response.result.isQRCodeScanned === true){
                      setQRscanned(true)
                    }
                      setQRscanned(true)
                  }
              }
              setShowSpinner(false);
            }  
           
          }
        });
      };

      const handleVerifyPass = () => {
        setAddVerifyBtn(false)
        setSuccessVerify(true)
        handleUpdateVerifyPass()
    }

    const handleUpdateVerifyPass = () => {
      if(invitation.passengers !== undefined){  
        const passenger = invitation.passengers.find((pass) => pass.connectedCustomerTravel === id);
        if (passenger) {
          passenger.isQRCodeScanned = true;
        }

        fetchSadirTravel(invitation, function(response){
        }).then(()=>{
          alert('עליית הנוסע אושרה')
        }).catch(()=>{
          alert(' שגיאה  ')
        });

      }else{
          invitation.isQRCodeScanned = true ; 
        fetchUpdateTravel(invitation, function(response){
         }).then(()=>{
           alert('עליית הנוסע אושרה')
         }).catch(()=>{
           alert(' שגיאה  ')
         });
      }
      
    }

  return (
      <div className='card'>
         <div style={{ 'textAlign': 'center'}}>
                    <img src="/logo-pych.png" alt="logo-pych"/>
            </div>
          {showSpinner ?
              <Box sx={{ textAlign: 'center', margin: '50px 0' }}>
                  <CircularProgress sx={{ color: '#1a253a' }} size={100}></CircularProgress>
              </Box>
              : ""}
              {verifyBtn ?
              <div>
            <h6 className="headerBack" style={{textAlign : 'center'}}>פרטי נסיעה  </h6>
                <div className='parameter'>
                    <span>{invitation.dateStartTraveling || invitation.date}</span>
                    <span style={{ fontWeight: 'bold' }}>  : תאריך </span>
                    </div>
                    <div className='parameter'>
                    <span>{invitation.hourStartTraveling || invitation.time}</span>
                    <span style={{ fontWeight: 'bold' }}>  : שעה </span>
                    </div>
                    <div className='parameter'>
                    <span>{invitation.orbit.name || invitation.orbit.hebrewAdress}</span>
                    <span style={{ fontWeight: 'bold' }}>  : מסלול </span>
                    </div>
                    <div className='parameter'>
                    <span>{passenger.name || invitation.name}</span>
                    <span style={{ fontWeight: 'bold' }}>  : שם </span>
                    </div>
                    <div className='parameter'>
                    <span>{passenger.amountOfPassengers || invitation.amount}</span>
                    <span style={{ fontWeight: 'bold' }}>  : כמות </span>
                    </div>
                <button className='verifyBtn' onClick={handleVerifyPass} variant="contained">אשר עליית נוסע</button>
                </div>
              : ""}
              {successVerify ?
              <h4 className='titles'> עליית הנוסע אושרה בהצלחה </h4>
                : ""}
                 {QRscanned ?
                 <div>
              <h4 className='titles'> קישור זה כבר נסרק בעבר  </h4>
              <h4 className='titles'>  This link has been scanned before </h4>
              </div>
                : ""}
     </div>
  )
}

export default VerifyInvite